import * as React from "react";
import { alpha } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
// import TableSortLabel from "@mui/material/TableSortLabel";
// import { visuallyHidden } from "@mui/utils";

function getComparator(order, orderBy) {
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  return order === "desc" ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "activity",
    rightAligned: false,
    label: "Activity",
  },
  {
    id: "module",
    rightAligned: false,
    label: "Module",
  },
  {
    id: "startField",
    rightAligned: false,
    label: "Start Field",
  },
  {
    id: "endField",
    rightAligned: false,
    label: "End Field",
  },
  {
    id: "color",
    rightAligned: false,
    label: "Color",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy } = props;
  // const { order, orderBy, onRequestSort } = props;
  // const createSortHandler = (property) => (event) => {
  //   onRequestSort(event, property);
  // };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            sx={(theme) => {
              return {
                ...(index === 0 ? { borderTopLeftRadius: "4px" } : {}),
                ...(index + 1 === headCells?.length ? { borderTopRightRadius: "4px" } : {}),
                bgcolor: "primary.main",
                color: "primary.contrastText",
                "& span:hover": {
                  color: alpha(theme.palette.primary.contrastText, 0.5),
                },
                "& span.Mui-active": {
                  color: "primary.contrastText",
                  "& svg": { color: "inherit !important" },
                },
              };
            }}
            key={headCell.id}
            // align={headCell.rightAligned ? "right" : "left"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.label}
            {/* <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel> */}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export function SettingsTable({ rows, onSelectRow }) {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const onRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () => [...rows].sort(getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rows, rowsPerPage]
  );

  return (
    <Paper sx={{ width: "100%", mb: 2 }}>
      <TableContainer>
        {/* <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size="small"> */}
        <Table aria-labelledby="tableTitle" size="small">
          <EnhancedTableHead
            order={order}
            orderBy={orderBy}
            // onRequestSort={onRequestSort}
          />
          <TableBody>
            {visibleRows.map((row, index) => {
              const settingId = row.setting_id;
              //   const isItemSelected = selected.includes(row.id);
              const labelId = `enhanced-table-checkbox-${index}`;

              return (
                <TableRow
                  hover
                  onClick={(event) => {
                    onSelectRow(settingId);
                  }}
                  //   onClick={(event) => {
                  //  handleClick(event, row.id);
                  //}}
                  //   role="checkbox"
                  //   aria-checked={isItemSelected}
                  //   selected={isItemSelected}
                  tabIndex={-1}
                  key={settingId}
                  sx={{ cursor: "pointer" }}
                >
                  <TableCell component="th" id={labelId} scope="row">
                    {row.activity}
                  </TableCell>
                  <TableCell>{row.module.plural_label}</TableCell>
                  <TableCell>{row.startTimeField.display_label}</TableCell>
                  <TableCell>{row.endTimeField.display_label}</TableCell>
                  <TableCell sx={{ bgcolor: row.eventColor }} />
                </TableRow>
              );
            })}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: 33 * emptyRows,
                }}
              >
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
